module.exports = __webpack_public_path__ + "static/media/card_brand_alelo.6fb07659.svg";